import { DeviceIdentificationType } from '@quadminds/shared/tracking-system';

export interface IIdentificationDto {
    type: DeviceIdentificationType;
    value: string;
}
